<template>
  <v-card-title class="px-2 py-2 bg-systock-1 text-white font-weight-regular">
    <div class="d-flex align-center w-35-porcento">
      <v-btn icon dark @click="$emit('fechar-dialog', {})">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="ml-3">
        <p class="ma-0 font-20 font-weight-bold">
          <v-icon dark size="22" class="mr-n1 mt-n1">mdi-cart</v-icon>
          Carrinho de compra #{{PEDIDO_SELECIONADO.idpedido || '0'}}
        </p>

        <p class="ma-0 font-12 mt-n3 text-truncate">
          <template v-if="PEDIDO_SELECIONADO.idpedido">
            {{ `Aberto em ${PEDIDO_SELECIONADO.data_emissao}` }}
            <template v-if="PEDIDO_SELECIONADO.inicio_cotacao">{{ ` e em cotação desde ${PEDIDO_SELECIONADO.inicio_cotacao}` }}</template>
          </template>

          <template v-else>
            Nenhum pedido de compra aberto
          </template>
        </p>
      </div>
    </div>

    <div v-if="PEDIDO_SELECIONADO.pedido_produtos_combinados" class="w-50-porcento d-flex align-center" style="padding-left: 3%;">
      <CotacaoCombinadosAutomatiza
        v-if="integracao_exportacao_automatiza"
        :ids_pedidos_compras="IDS_PEDIDOS_COMPRAS_COMBINADOS"
      />

      <CotacaoProdutosCombinados v-else :pedidoSelecionado="PEDIDO_SELECIONADO" />

      <AbrirPedidoProdutosCombinados
        content_class="ml-5"
        :ids_pedidos_compras="IDS_PEDIDOS_COMPRAS_COMBINADOS"
        :idfornecedor_pedido="info_pedido_geral.idfornecedor_produtos_combiados"
        @salvo-fornecedor-final-cotacao="CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO()"
      />
    </div>

    <template v-else>
      <div class="d-flex align-center justify-center w-30-porcento z-999 bg-systock-1">
        <RelatoriosCarrinho
          :pedido_selecionado="PEDIDO_SELECIONADO"
          :pedidos="pedidos"
          :produtos_pedido_selecionado="produtos_pedido_selecionado"
        />
      </div>

      <div class="w-20-porcento">
        <Webcotacao v-if="compraVisualizarWebcotacao" :pedido-id="PEDIDO_SELECIONADO.idpedido"/>

        <div v-else>
          <v-btn
            v-if="PEDIDO_SELECIONADO.status === 'AB'"
            class="btn-titulo"
            color="primary"
            @click="abrirCotacao()"
            v-text="'Abrir Cotação'"
          />

          <v-btn
            v-else
            class="btn-titulo"
            color="primary"
            @click="finalizarPedido()"
            v-text="'Finalizar'"
          />
        </div>
      </div>
    </template>

    <div class="d-flex align-center justify-end w-15-porcento pl-10 pr-2">
      <div class="font-16 h-50px text-right">
        <p class="ma-0">
          <span class="font-weight-medium">Total:&nbsp;</span>
          <span v-text="`R$ ${formatarNumero(TOTAIS_PEDIDO.valor)}`" />
        </p>

        <p class="ma-0 mt-n3">
          <span class="font-weight-medium">Total Saving:&nbsp;</span>
          <span
            :class="{'text-green-positivo': TOTAIS_PEDIDO.saving < 0, 'text-red-negativo': TOTAIS_PEDIDO.saving > 0}"
            v-text="`R$ ${formatarNumero(Math.abs(TOTAIS_PEDIDO.saving))}`"
          />
        </p>
      </div>
    </div>
  </v-card-title>
</template>

<script>
import {pedidos_mixin} from "@/components/compra/ProdutosGerais/Carrinho/PedidosMixin";
import CarrinhoAPI from "@/api/carrinho";
import {formatarValor, logout} from "@/helpers";
import RelatoriosCarrinho from "@/components/compra/ProdutosGerais/Carrinho/RelatoriosCarrinho";
import CotacaoProdutosCombinados from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/Index.vue";
import AbrirPedidoProdutosCombinados from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/AbrirPedido/Index.vue";
import CotacaoCombinadosAutomatiza from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/Automatiza/Index.vue";
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import Webcotacao from "@/components/webcotacao/components/WebcotacaoDialog.vue";

export default {
  name: "TituloCarrinhoCompraProdutosGerais",
  components: {
    Webcotacao,
    RelatoriosCarrinho,
    CotacaoProdutosCombinados,
    AbrirPedidoProdutosCombinados,
    CotacaoCombinadosAutomatiza,
  },
  mixins: [pedidos_mixin],
  props: {
    produtos_pedido_selecionado: Array
  },
  data: () => ({
    integracao_exportacao_automatiza: localStorage.getItem('integracao_exportacao_automatiza') === 'S',
    compraVisualizarWebcotacao: localStorage.getItem('compra_visualizar_webcotacao_ativo') === 'S',
  }),
  computed: {
    info_pedido_geral() {
      return info_pedido_geral
    },
    TOTAIS_PEDIDO() {
      const totais = {valor: 0, saving: 0};

      if (this.produtos_pedido_selecionado.length === 0) {
        return totais;
      }

      const callback = (a, b) => {
        const qtde_pedido = Number(b.qtde_pedido || 0);
        const preco_custo = Number(b.preco_custo || 0);
        const preco_custo_base = Number(b.preco_custo_base || 0);

        return {
          valor: a.valor + (qtde_pedido * preco_custo),
          saving: a.saving + (qtde_pedido * (preco_custo - preco_custo_base)),
        };
      };
      return this.produtos_pedido_selecionado.reduce(callback, totais);
    },
    IDS_PEDIDOS_COMPRAS_COMBINADOS() {
      return this.PEDIDO_SELECIONADO.filial > 0
        ? this.pedidos.filter(item => item.pedido_produtos_combinados).map(pedido => pedido.idpedido)
        : [this.PEDIDO_SELECIONADO.idpedido];
    }
  },
  methods: {
    formatarNumero: formatarValor,
    abrirCotacao() {
      if (!(this.PEDIDO_SELECIONADO.idpedido > 0)) {
        return
      }

      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        pedido: this.PEDIDO_SELECIONADO.idpedido
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.abrirCotacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.token = token;
            this.CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO();
          })
          .catch(logout)
      );
    },
    finalizarPedido() {
      if (!(this.PEDIDO_SELECIONADO.idpedido > 0)) {
        return
      }

      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        pedido: this.PEDIDO_SELECIONADO.idpedido
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.finalizarPedido(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.token = token;
            this.CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
.text-green-positivo {
  color: #17ff17;
}
.text-red-negativo {
  color: #ff4b4b;
}
</style>
